import React, { useEffect, useContext, useState, useRef } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid";
import LottiePlayer from "react-lottie-player";
import myData from "../assets/DefaultCharacter/Male/Default_Standing.json";
import FData from "../assets/DefaultCharacter/Female/Default_Standing.json";
import axios from "axios";
import AuthContext from "../context/userAuth.context";
import Lottie from "lottie-web";
import FormLabel from "@mui/material/FormLabel";
import ColorPickerIn from "../Editor/ColorPickerIn";
import SmartColorPicker from "./SmartColorPicker";
import { Login } from "@mui/icons-material";

function DefaultCharacterView(props) {
  const [StaticData, setStaticData] = useState([]);
  const [isCap, setIsCap] = useState(false);
  const [isShirt, setIsShirt] = useState(false);
  const [isBottom, setIsBottom] = useState(false);
  const [isGlasses, setIsGlasses] = useState(false);
  const [isCoat, setIsCoat] = useState(false);
  const [isHair, setIsHair] = useState(false);
  const [isBeard, setIsBeard] = useState(false);
  const [currentAsset, setCurrentAsset] = useState("");

  var initialState = [{ gestureName: "", type: "" }];

  const [currentArray, setcurrentArray] = useState(null);

  var [settings, setSettings] = useState(initialState);

  const [temp, settemp] = useState("");
  const [gender, setGender] = useState("Male");

  const [currentJSON, setCurrentJSON] = useState(null);
  const [allDefaultGesturesJSON, setAllDefaultGesturesJSON] = useState([]);
  const [allUpdatedGesturesJSON, setAllUpdatedGesturesJSON] = useState([]);
  const [showAppearanceComp, setshowApperanceComp] = useState(false);

  const { authenticationData, Role } = useContext(AuthContext);
  const playerRef = useRef(null);
  const refnew = useRef();
  let authData = JSON.parse(
    localStorage.getItem("animation_studio_2.0_access_token")
  );
  const [defaultColorSettings, setDefaultColorSettings] = React.useState([{}]);

  useEffect(() => {
    getStaticCharacters("Male");      
    getALLDefaultGestures("Male");   
    setCurrentJSON(myData);
    //setCurrentJSON({ ...currentJSON, myData });
    setDefaultColorSettings(PartNames);
    LoadDefaultColorSettings(myData);
    localStorage.removeItem("Settings");
  }, []);

  var PartNames = [
    {
      id: "1",
      name: "Hair",
      rgb: "",
    },
    {
      id: "2",
      name: "Skin",
      rgb: "",
    },
    {
      id: "3",
      name: "Shirt",
      rgb: "",
    },
    {
      id: "4",
      name: "EyeBro",
      rgb: "",
    },
    {
      id: "5",
      name: "Glasses",
      rgb: "",
    },
    {
      id: "6",
      name: "Bottom",
      rgb: "",
    },
    {
      id: "7",
      name: "Shoe",
      rgb: "",
    },
    {
      id: "8",
      name: "Eye",
    },
    {
      id: "9",
      name: "Beard",
      rgb: "",
    },
    {
      id: "10",
      name: "Coat",
      rgb: "",
    },
    {
      id: "11",
      name: "Tie",
      rgb: "",
    },
    {
      id: "12",
      name: "Cap",
      rgb: "",
    },
    {
      id: "13",
      name: "Mustache",
      rgb: "",
    },
    {
      id: "14",
      name: "Leg_L",
      rgb: "",
    },
    {
      id: "15",
      name: "Leg_R",
      rgb: "",
    },
    {
      id: "16",
      name: "Hip",
      rgb: "",
    },
    {
      id: "17",
      name: "Arm_R",
      rgb: "",
    },
    {
      id: "18",
      name: "Arm_L",
      rgb: "",
    },
    {
      id: "19",
      name: "ForeArm_L",
      rgb: "",
    },
    {
      id: "20",
      name: "ForeArm_R",
      rgb: "",
    },
    {
      id: "21",
      name: "Calf_L",
      rgb: "",
    },
    {
      id: "22",
      name: "Calf_R",
      rgb: "",
    },
    {
      id: "23",
      name: "Mask",
      rgb: "",
    },
    {
      id: "24",
      name: "EarBud",
      rgb: "",
    },
    {
      id: "25",
      name: "Chain",
      rgb: "",
    },
    {
      id: "26",
      name: "EarRing",
      rgb: "",
    },
    {
      id: "27",
      name: "Hair1",
      rgb: "",
    },
  ];

  const getStaticCharacters = (gender) => {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Character/GetStaticCharactersByGender?catId=3&gender="+gender+"",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setStaticData([...response.data.characters]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {}, [StaticData]);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "100%",
    bgcolor: "background.paper",
  };

  const closeCharachterbuilder = () => {
    props.setShowSmartCharaterBuilderPanel(false);
  };

  const setMask = async (e) => {
    e.preventDefault();
    let newTodos = [];
    let target = e.currentTarget;
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Mask", newTodos).then(() => {
        removeMask(e);
      });
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Mask",
        newTodos
      );
    }
  };

  const setEarbud = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "EarBud", newTodos).then(
        () => {
          removeEarBud(e);
        }
      );
      //await getAllDefaultCharLayerByName("Null", "EarBud2");
      //await getAllDefaultCharLayerByName("Null", "EarBud3");
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "EarBud",
        newTodos
      );
    }
  };

  const setChain = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Chain", newTodos).then(() => {
        removeChain(e);
      });
      //await getAllDefaultCharLayerByName("Null", "Chain1");
      //await getAllDefaultCharLayerByName("Null", "Chain2");
      //await getAllDefaultCharLayerByName("Null", "Chain3");
      //await getAllDefaultCharLayerByName("Null", "Chain4");
      //await getAllDefaultCharLayerByName("Null", "Chain5");
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Chain",
        newTodos
      );
    }
  };

  const setEarRing = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "EarRing", newTodos).then(
        () => {
          removeRing(e);
        }
      );
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "EarRing",
        newTodos
      );
    }
  };

  const setShirt = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];

    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Shirt", newTodos).then(() => {
        getAllDefaultCharLayerByName("Null", "Arm_L", newTodos).then(() => {
          getAllDefaultCharLayerByName("Null", "Arm_R", newTodos).then(() => {
            getAllDefaultCharLayerByName("Null", "ForeArm_L", newTodos).then(
              () => {
                getAllDefaultCharLayerByName(
                  "Null",
                  "ForeArm_R",
                  newTodos
                ).then(() => {
                  removeShirt(e);
                });
              }
            );
          });
        });
      });
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Shirt",
        newTodos
      ).then(() => {
        getAllDefaultCharLayerByName(
          authenticationData.ApiBaseURL + "/" + target.id,
          "Arm_R",
          newTodos
        ).then(() => {
          getAllDefaultCharLayerByName(
            authenticationData.ApiBaseURL + "/" + target.id,
            "Arm_L",
            newTodos
          ).then(() => {
            getAllDefaultCharLayerByName(
              authenticationData.ApiBaseURL + "/" + target.id,
              "ForeArm_L",
              newTodos
            ).then(() => {
              getAllDefaultCharLayerByName(
                authenticationData.ApiBaseURL + "/" + target.id,
                "ForeArm_R",
                newTodos
              ).then(() => {
                var json = (async () => {
                  const resp = await fetch(
                    authenticationData.ApiBaseURL + "/" + target.id
                  );
                  const jsonData = await resp.json();
                  setShirtLayers(jsonData);
                  return jsonData;
                })();
              });
            });
          });
        });
      });
    }

    //setDefaultStandingCharLayerByName(e.currentTarget.id);
  };

  useEffect(() => {
    //console.log(settings);
  }, [settings]);

  function setDefaultStandingCharLayerByName(jsonPath) {
    var json = (async () => {
      const resp = await fetch(authenticationData.ApiBaseURL + "/" + jsonPath);
      const jsonData = await resp.json();
      //setCurrentJSON(jsonData);

      setShirtLayers(jsonData);
      return jsonData;
    })();
  }

  async function getAllDefaultCharLayerByName(layerName, type, newTodos) {
    return new Promise(function (resolve) {
      if (localStorage.getItem("Settings") != null)
        newTodos = JSON.parse(localStorage.getItem("Settings"));

      if (layerName === "Null") {
        for (let index = 0; index < allDefaultGesturesJSON.length; index++) {
          if (newTodos.length < allDefaultGesturesJSON.length) {
            newTodos.push({
              gestureName: allDefaultGesturesJSON[index],
              [type]: null,
            });
          } else {
            for (let it = 0; it < newTodos.length; it++) {
              if (newTodos[it].gestureName == allDefaultGesturesJSON[index]) {
                newTodos[it][type] = null;
              }
            }
          }
        }
        resolve();
      } else {
        getAllGesturesBySelectedCharacter(layerName, newTodos, type, resolve);
      }
      localStorage.setItem("Settings", JSON.stringify(newTodos));
    });
  }

  async function setLayersProcess(
    newTodos,
    jsonData,
    type,
    targetLayerName,
    TargetjsonData,
    resolve,
    flag,
    filename1,
    filename2
  ) {
    for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
      var name = jsonData.assets[0].layers[Layr].nm;
      if (
        type.trim().toLowerCase() === name.trim().toLowerCase() &&
        filename1.split("_")[1] === filename2.split("_")[1]
      ) {
        jsonData.assets[0].layers[Layr].parent =
          TargetjsonData.assets[0].layers.find((x) => x.nm == name).parent;
        jsonData.assets[0].layers[Layr].ind =
          TargetjsonData.assets[0].layers.find((x) => x.nm == name).ind;
        var finalLayer = jsonData.assets[0].layers[Layr];

        if (newTodos.length < allDefaultGesturesJSON.length) {
          newTodos.push({
            gestureName: targetLayerName,
            [type]: finalLayer,
          });
        } else {
          for (let it = 0; it < newTodos.length; it++) {
            if (newTodos[it].gestureName == targetLayerName) {
              newTodos[it][type] = finalLayer;
              break;
            }
          }
        }
        if (
          newTodos.length === allDefaultGesturesJSON.length &&
          flag == newTodos.length
        ) {
          resolve();
        }
        break;
      }
    }
    return newTodos;
  }

  const setPant = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      // await getAllDefaultCharLayerByName("Null", "Hip", newTodos);
      // await getAllDefaultCharLayerByName("Null", "Leg_R", newTodos);
      // await getAllDefaultCharLayerByName("Null", "Leg_L", newTodos);
      // await getAllDefaultCharLayerByName("Null", "Calf_L", newTodos);
      // await getAllDefaultCharLayerByName("Null", "Calf_R", newTodos);
      await getAllDefaultCharLayerByName("Null", "Hip", newTodos).then(() => {
        getAllDefaultCharLayerByName("Null", "Leg_L", newTodos).then(() => {
          getAllDefaultCharLayerByName("Null", "Leg_R", newTodos).then(() => {
            getAllDefaultCharLayerByName("Null", "Calf_L", newTodos).then(
              () => {
                getAllDefaultCharLayerByName("Null", "Calf_R", newTodos).then(
                  () => {
                    removeBottom(e);
                  }
                );
              }
            );
          });
        });
      });
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Hip",
        newTodos
      ).then(() => {
        getAllDefaultCharLayerByName(
          authenticationData.ApiBaseURL + "/" + target.id,
          "Leg_L",
          newTodos
        ).then(() => {
          getAllDefaultCharLayerByName(
            authenticationData.ApiBaseURL + "/" + target.id,
            "Leg_R",
            newTodos
          ).then(() => {
            getAllDefaultCharLayerByName(
              authenticationData.ApiBaseURL + "/" + target.id,
              "Calf_L",
              newTodos
            ).then(() => {
              getAllDefaultCharLayerByName(
                authenticationData.ApiBaseURL + "/" + target.id,
                "Calf_R",
                newTodos
              ).then(() => {
                var json = (async () => {
                  const resp = await fetch(
                    authenticationData.ApiBaseURL + "/" + target.id
                  );
                  const jsonData = await resp.json();
                  setPantLayers(jsonData);
                  return jsonData;
                })();
              });
            });
          });
        });
      });
    }
  };

  const setCoat = async (e) => {
    e.preventDefault();
    let newTodos = [];
    let target = e.currentTarget;
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Coat", newTodos).then(() => {
        removeCoat(e);
      });
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Coat",
        newTodos
      ).then(() => {
        getAllDefaultCharLayerByName(
          authenticationData.ApiBaseURL + "/" + target.id,
          "Arm_R",
          newTodos
        ).then(() => {
          getAllDefaultCharLayerByName(
            authenticationData.ApiBaseURL + "/" + target.id,
            "Arm_L",
            newTodos
          ).then(() => {
            getAllDefaultCharLayerByName(
              authenticationData.ApiBaseURL + "/" + target.id,
              "ForeArm_L",
              newTodos
            ).then(() => {
              getAllDefaultCharLayerByName(
                authenticationData.ApiBaseURL + "/" + target.id,
                "ForeArm_R",
                newTodos
              ).then(() => {
                var json = (async () => {
                  const resp = await fetch(
                    authenticationData.ApiBaseURL + "/" + target.id
                  );
                  const jsonData = await resp.json();
                  setCoatLayers(jsonData);
                  return jsonData;
                })();
              });
            });
          });
        });
      });
    }
  };

  function removeLayer(namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        currentJSON.assets[0].layers[Layr].hd = true;
        setCurrentJSON({ ...currentJSON, currentJSON });
        break;
      }
    }
    removeItemAllgestures(namelyr);
  }

  function setCoatLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Coat") {
        UpdateDefaultCoatLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Arm_L") {
        UpdateDefaultCoatLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Arm_R") {
        UpdateDefaultCoatLayer(json.assets[0].layers[Layr], name);
      } else if (name == "ForeArm_L") {
        UpdateDefaultCoatLayer(json.assets[0].layers[Layr], name);
      } else if (name == "ForeArm_R") {
        UpdateDefaultCoatLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultCoatLayer(pantLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        pantLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        pantLayer.ind = currentJSON.assets[0].layers[Layr].ind;
        currentJSON.assets[0].layers[Layr] = pantLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        break;
      }
    }
  }

  function setPantLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hip") {
        UpdateDefaultPantLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Leg_R") {
        UpdateDefaultPantLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Leg_L") {
        UpdateDefaultPantLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Calf_L") {
        UpdateDefaultPantLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Calf_R") {
        UpdateDefaultPantLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultPantLayer(pantLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        pantLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        pantLayer.ind = currentJSON.assets[0].layers[Layr].ind;
        currentJSON.assets[0].layers[Layr] = pantLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        break;
      }
    }
  }

  function setShirtLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        UpdateDefaultShirtLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Arm_L") {
        UpdateDefaultShirtLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Arm_R") {
        UpdateDefaultShirtLayer(json.assets[0].layers[Layr], name);
      } else if (name == "ForeArm_L") {
        UpdateDefaultShirtLayer(json.assets[0].layers[Layr], name);
      } else if (name == "ForeArm_R") {
        UpdateDefaultShirtLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultShirtLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        shirtLayer.ind = currentJSON.assets[0].layers[Layr].ind;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  useEffect(() => {
    //alert("JSON Updated");
  }, [currentJSON]);

  const ProceedToAppearanceWindow = () => {
    setshowApperanceComp(true);
  };

  const ProceedToOutfitWindow = () => {
    setshowApperanceComp(false);
  };

  const setCap = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      await getAllDefaultCharLayerByName("Null", "Cap", newTodos).then(() => {
        removeCap(e);
      });
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Cap",
        newTodos
      ).then(() => {
        var json = (async () => {
          const resp = await fetch(
            authenticationData.ApiBaseURL + "/" + target.id
          );
          const jsonData = await resp.json();
          setCapLayers(jsonData);
          return jsonData;
        })();
      });
    }
  };

  const getAllGesturesBySelectedCharacter = async (
    fileid,
    newTodos,
    type,
    resolve
  ) => {
    var charRoot = fileid.split("/")[fileid.split("/").length - 2];

    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getGesturesBySelectedCharachter?path=" +
          charRoot,
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then(async (response) => {
        let flag = 0;
        for (let index = 0; index < response.data.response.length; index++) {
          var filename1 = response.data.response[index].split("/").pop();
          var filename2 = allDefaultGesturesJSON[index].split("/").pop();
          if (filename1.split("_")[1] === filename2.split("_")[1]) {
            if (flag == response.data.response.length) {
              flag = 0;
            } else flag++;
            const resp = await fetch(response.data.response[index]);
            const jsonData = await resp.json();
            const targetResp = await fetch(allDefaultGesturesJSON[index]);
            const TargetjsonData = await targetResp.json();
            newTodos = await setLayersProcess(
              newTodos,
              jsonData,
              type,
              allDefaultGesturesJSON[index],
              TargetjsonData,
              resolve,
              flag,
              filename1,
              filename2
            );
            localStorage.setItem("Settings", JSON.stringify(newTodos));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const removeItemAllgestures = (layerName) => {
    if (allUpdatedGesturesJSON.length === 0) {
      allDefaultGesturesJSON.forEach((element) => {
        (async () => {
          const resp = await fetch(element);
          const jsonData = await resp.json();
          for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
            var name = jsonData.assets[0].layers[Layr].nm;
            if (name === layerName) {
              jsonData.assets[0].layers[Layr].hd = true;

              var formdata = new FormData();
              var filename = element.split("/").pop();
              formdata.append("jsonData", JSON.stringify(jsonData));
              formdata.append("gestureFileName", filename);
              formdata.append("gender", gender);
              axios
                .post(
                  authenticationData.ApiBaseURL +
                    "/api/Administration/CreateTempCharacterGestureFile",
                  formdata,
                  {
                    headers: {
                      "Content-Type": `multipart/form-data`,
                      "Access-Control-Allow-Origin": "*",
                      Authorization: "Bearer " + authData.access_token,
                    },
                  }
                )
                .then((response) => {})
                .catch((excetion) => {});
            }
          }
        })();
      });
    } else {
      allUpdatedGesturesJSON.forEach((element) => {
        (async () => {
          const resp = await fetch(element);
          const jsonData = await resp.json();
          for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
            var name = jsonData.assets[0].layers[Layr].nm;
            if (name === layerName) {
              jsonData.assets[0].layers[Layr].hd = true;

              var formdata = new FormData();
              var filename = element.split("/").pop();
              formdata.append("jsonData", JSON.stringify(jsonData));
              formdata.append("gestureFileName", filename);
              formdata.append("gender", gender);
              axios
                .post(
                  authenticationData.ApiBaseURL +
                    "/api/Administration/CreateTempCharacterGestureFile",
                  formdata,
                  {
                    headers: {
                      "Content-Type": `multipart/form-data`,
                      "Access-Control-Allow-Origin": "*",
                      Authorization: "Bearer " + authData.access_token,
                    },
                  }
                )
                .then((response) => {})
                .catch((excetion) => {});
            }
          }
        })();
      });
    }
  };

  useEffect(() => {
    setAllgesturesCapLayer();
  }, [allUpdatedGesturesJSON]);

  function setAllgesturesCapLayer(a) {
    allUpdatedGesturesJSON.forEach((element1) => {
      var filename1 = element1.split("\\").pop();
      allDefaultGesturesJSON.forEach((element2) => {
        var filename2 = element2.split("/").pop();
        if (filename1.split("_")[1] == filename2.split("_")[1]) {
          (async () => {
            const resp = await fetch(element1);
            const jsonData = await resp.json();
            for (
              var Layr = 0;
              Layr < jsonData.assets[0].layers.length;
              Layr++
            ) {
              var name = jsonData.assets[0].layers[Layr].nm;

              if (currentAsset == "Cap" && name == "Cap") {
                UpdateDefaultAllGesturesCapLayer(
                  jsonData.assets[0].layers[Layr],
                  name,
                  element2
                );
              } else if (currentAsset == "Shirt" && name == "Shirt") {
                UpdateDefaultAllGesturesCapLayer(
                  jsonData.assets[0].layers[Layr],
                  name,
                  element2
                );
              }
            }
          })();
        }
      });
    });
  }

  function UpdateDefaultAllGesturesCapLayer(Layer, namelyr, element2) {
    (async () => {
      const resp = await fetch(element2);
      const jsonData = await resp.json();
      for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
        var name = jsonData.assets[0].layers[Layr].nm;
        if (name == namelyr) {
          Layer.parent = jsonData.assets[0].layers[Layr].parent;
          Layer.ind = jsonData.assets[0].layers[Layr].ind;
          jsonData.assets[0].layers[Layr] = Layer;
          var formdata = new FormData();
          var filename = element2.split("/").pop();
          formdata.append("jsonData", JSON.stringify(jsonData));
          formdata.append("gestureFileName", filename);
          formdata.append("gender", gender);
          
          axios
            .post(
              authenticationData.ApiBaseURL +
                "/api/Administration/CreateTempCharacterGestureFile",
              formdata,
              {
                headers: {
                  "Content-Type": `multipart/form-data`,
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {})
            .catch((excetion) => {});
          break;
        }
      }
    })();
  }

  function setCapLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Cap") {
        UpdateDefaultCapLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Hair") {
        UpdateDefaultCapLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultCapLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  const setHair = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Hair", newTodos).then(
        () => {
          getAllDefaultCharLayerByName("Null", "Hair1", newTodos).then(
            () => {
              removeHair(e);
            }
          );
        }
      );
     
      //await getAllDefaultCharLayerByName("Null", "Hair1", newTodos);
      //await getAllDefaultCharLayerByName("Null", "EarBud2");
      //await getAllDefaultCharLayerByName("Null", "EarBud3");
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Hair",
        newTodos
      ).then(() => {
        getAllDefaultCharLayerByName(
          authenticationData.ApiBaseURL + "/" + target.id,
          "Hair1",
          newTodos
        ).then(() => {
          var json = (async () => {
            const resp = await fetch(
              authenticationData.ApiBaseURL + "/" + target.id
            );
            const jsonData = await resp.json();
            //setCurrentJSON(jsonData);
    
            setHairLayers(jsonData);
            return jsonData;
          })();
        });
      
      
      })
    }
  };

  function setHairLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hair") {
        UpdateDefaultHairLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Hair1") {
        UpdateDefaultHairLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultHairLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  const setBeardColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Beard") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Beard_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setMaskColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Mask") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Mask_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setBeard = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      //Reading All Default Character 60 Gestures Layer by Name
      await getAllDefaultCharLayerByName("Null", "Beard", newTodos);
      removeBeard(e);
      //await getAllDefaultCharLayerByName("Null", "EarBud2");
      //await getAllDefaultCharLayerByName("Null", "EarBud3");
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Beard",
        newTodos
      );
      var json = (async () => {
        const resp = await fetch(
          authenticationData.ApiBaseURL + "/" + target.id
        );
        const jsonData = await resp.json();
        //setCurrentJSON(jsonData);

        setBeardLayers(jsonData);
        return jsonData;
      })();
    }
    /**Real Time State Update */
    // var json = (async () => {
    //   const resp = await fetch(
    //     authenticationData.ApiBaseURL + "/" + e.currentTarget.id
    //   );
    //   const jsonData = await resp.json();
    //   //setCurrentJSON(jsonData);

    //   setBeardLayers(jsonData);
    //   return jsonData;
    // })();
  };

  function setBeardLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Beard") {
        UpdateDefaultBeardLayer(json.assets[0].layers[Layr], name);
      } else if (name == "Mouth") {
        UpdateDefaultMouthLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultBeardLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        shirtLayer.ind = currentJSON.assets[0].layers[Layr].ind;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  function UpdateDefaultMouthLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        shirtLayer.ind = 9;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  const removeCoat = (e) => {
    e.preventDefault();
    removeLayer("Coat");
    removeLayer("Arm_L");
    removeLayer("Arm_R");
    removeLayer("ForeArm_R");
    removeLayer("ForeArm_L");
  };

  const removeShirt = (e) => {
    removeLayer("Shirt");
    removeLayer("Arm_L");
    removeLayer("Arm_R");
    removeLayer("ForeArm_R");
    removeLayer("ForeArm_L");
  };

  const removeGlasses = (e) => {
    e.preventDefault();
    removeLayer("Glasses");
  };

  const removeCap = (e) => {
    e.preventDefault();
    removeLayer("Cap");
  };

  const removeBottom = (e) => {
    e.preventDefault();
    removeLayer("Hip");
    removeLayer("Calf_R");
    removeLayer("Calf_L");
    removeLayer("Leg_R");
    removeLayer("Leg_L");
  };

  const removeBeard = (e) => {
    e.preventDefault();
    removeLayer("Beard");
  };

  const removeHair = (e) => {
    e.preventDefault();
    removeLayer("Hair");
    removeLayer("Hair1");
  };

  const removeMask = (e) => {
    e.preventDefault();
    removeLayer("Mask");
  };

  const removeEarBud = (e) => {
    e.preventDefault();
    removeLayer("EarBud");
  };

  const removeRing = (e) => {
    e.preventDefault();
    removeLayer("EarRing");
  };

  const removeChain = (e) => {
    e.preventDefault();
    removeLayer("Chain");
  };

  const setGlasses = async (e) => {
    e.preventDefault();
    let target = e.currentTarget;
    let newTodos = [];
    if (e.target.value == "Null") {
      await getAllDefaultCharLayerByName("Null", "Glasses", newTodos).then(
        () => {
          removeGlasses(e);
        }
      );
    } else {
      await getAllDefaultCharLayerByName(
        authenticationData.ApiBaseURL + "/" + target.id,
        "Glasses",
        newTodos
      ).then(() => {
        var json = (async () => {
          const resp = await fetch(
            authenticationData.ApiBaseURL + "/" + target.id
          );
          const jsonData = await resp.json();
          //setCurrentJSON(jsonData);

          setGlassesLayers(jsonData);
          return jsonData;
        })();
      });
    }
  };

  function setGlassesLayers(json) {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Glasses") {
        UpdateDefaultGlassesLayer(json.assets[0].layers[Layr], name);
      }
    }
  }

  function UpdateDefaultGlassesLayer(shirtLayer, namelyr) {
    for (var Layr = 0; Layr < currentJSON.assets[0].layers.length; Layr++) {
      var name = currentJSON.assets[0].layers[Layr].nm;
      if (name == namelyr) {
        shirtLayer.parent = currentJSON.assets[0].layers[Layr].parent;
        currentJSON.assets[0].layers[Layr] = shirtLayer;
        setCurrentJSON({ ...currentJSON, currentJSON });
        //alert("Updated");
      }
    }
  }

  const LoadDefaultColorSettings = (json) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hair") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Hair")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Cap") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Cap_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Cap")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Mustache") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Mustache_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Mustache")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Tie_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Tie")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Shirt")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Coat") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Coat")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Glasses") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Glasses_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter(
                  (part) => part.name.trim() == "Glasses"
                )[0].rgb = skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Eye_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Eye")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Shoe_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe2_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }

          skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe2_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name.trim() == "Shoe")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Hip") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Bottom")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "EyeBro") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "EyeBro")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Beard") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Beard_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Beard")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                PartNames.filter((part) => part.name == "Skin")[0].rgb =
                  skins[skn].it[it].c.k;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const SaveNewCharacter = () => {
    ExportSaveCharchter().then(() => {
      axios
        .get(
          authenticationData.ApiBaseURL +
            "/api/Administration/SaveNewStaticCharacter?gender="+gender+"&CategoryId=3",

          {
            headers: {
              "Content-Type": `multipart/form-data`,
              "Access-Control-Allow-Origin": "*",
              Authorization: "Bearer " + authData.access_token,
            },
          }
        )
        .then((response) => {
          alert("New Charachter Saved...");
        })
        .catch((excetion) => {});
    });
  };

  const setSkinColor = async (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Face") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "EyeShut1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "EyeShut2") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Body") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          for (var it = 0; it < skins.it.length; it++) {
            if (skins.it[it].ty === "fl") {
              skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
              skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
              skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
            }
          }
        }
      } else if (name == "Hand_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          if (skins != undefined) {
            for (var it = 0; it < skins.it.length; it++) {
              if (skins.it[it].ty === "fl") {
                skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
        }
      } else if (name == "Hand_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.find(
            (el) => el.nm == "Skin_ID"
          );
          if (skins != undefined) {
            for (var it = 0; it < skins.it.length; it++) {
              if (skins.it[it].ty === "fl") {
                skins.it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins.it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins.it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
        }
      } else if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Neck") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Ear_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Skin_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

    }
  };

  const setEyeColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Eye_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setEyeBro = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "EyeBro") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "Eye") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "EyeBro_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setShoeColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shoe_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          // skins = json.assets[0].layers[Layr].shapes.filter(
          //   (el) => el.nm.trim() == "Shoe2_ID"
          // );
          // for (var skn = 0; skn < skins.length; skn++) {
          //   for (var it = 0; it < skins[skn].it.length; it++) {
          //     if (skins[skn].it[it].ty === "fl") {
          //       skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
          //     }
          //   }
          // }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Shoe_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Shoe1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          // skins = json.layers[0].layers[Layr].shapes.filter(
          //   (el) => el.nm.trim() == "Shoe2_ID"
          // );
          // for (var skn = 0; skn < skins.length; skn++) {
          //   for (var it = 0; it < skins[skn].it.length; it++) {
          //     if (skins[skn].it[it].ty === "fl") {
          //       skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
          //       skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
          //     }
          //   }
          // }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setTieColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Tie_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setShirtColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Shirt") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Shirt_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }

          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setHairColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hair") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "Hair1") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Hair1_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setBottomColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Hip") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Leg_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      } else if (name == "Calf_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Bottom_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const setGlassesColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Glasses") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Glasses_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setCapColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Cap") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm.trim() == "Cap_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
        break;
      }
    }
  };

  const setCoatColor = (json, rgba) => {
    for (var Layr = 0; Layr < json.assets[0].layers.length; Layr++) {
      var name = json.assets[0].layers[Layr].nm;
      if (name == "Coat") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
      if (name == "ForeArm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "ForeArm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Arm_R") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }

      if (name == "Arm_L") {
        for (var i = 0; i < json.assets[0].layers[Layr].shapes.length; i++) {
          var skins = json.assets[0].layers[Layr].shapes.filter(
            (el) => el.nm == "Coat_ID"
          );
          for (var skn = 0; skn < skins.length; skn++) {
            for (var it = 0; it < skins[skn].it.length; it++) {
              if (skins[skn].it[it].ty === "fl") {
                skins[skn].it[it].c.k[0] = rgba[0].trim() / 25 / 10;
                skins[skn].it[it].c.k[1] = rgba[1].trim() / 25 / 10;
                skins[skn].it[it].c.k[2] = rgba[2].trim() / 25 / 10;
              }
            }
          }
          //console.log(skins.it[2].c);
        }
      }
    }
  };

  const ExportSaveCharchter = () => {
    return new Promise(function (resolve) {
      let finalJSON = "";
      allDefaultGesturesJSON.forEach((element, index, array) => {
        ExportCharacter(element).then((result) => {
          //console.log("got Result", result);
          var formdata = new FormData();
          var filename = element.split("/").pop();
          
          if(localStorage.getItem("SkinColor")!=undefined)
            setSkinColor(result,localStorage.getItem("SkinColor").split(','));

          if(localStorage.getItem("EyeColor")!=undefined)
            setEyeColor(result,localStorage.getItem("EyeColor").split(','));

          if(localStorage.getItem("EyeBroColor")!=undefined)
            setEyeBro(result,localStorage.getItem("EyeBroColor").split(','));
          
          if(localStorage.getItem("ShoeColor")!=undefined)
            setShoeColor(result,localStorage.getItem("ShoeColor").split(','));

          if(localStorage.getItem("TieColor")!=undefined)
            setTieColor(result,localStorage.getItem("TieColor").split(','));

          if(localStorage.getItem("HairColor")!=undefined)
            setHairColor(result,localStorage.getItem("HairColor").split(','));

          if(localStorage.getItem("ShirtColor")!=undefined)
            setShirtColor(result,localStorage.getItem("ShirtColor").split(','));
            
          if(localStorage.getItem("BottomColor")!=undefined)
            setBottomColor(result,localStorage.getItem("BottomColor").split(','));
          
          if(localStorage.getItem("CapColor")!=undefined)
            setCapColor(result,localStorage.getItem("CapColor").split(','));

          if(localStorage.getItem("BeardColor")!=undefined)
            setBeardColor(result,localStorage.getItem("BeardColor").split(','));

          if(localStorage.getItem("CoatColor")!=undefined)
            setCoatColor(result,localStorage.getItem("CoatColor").split(','));

          if(localStorage.getItem("GlassColor")!=undefined)
            setGlassesColor(result,localStorage.getItem("GlassColor").split(','));

          if(localStorage.getItem("MaskColor")!=undefined)
            setMaskColor(result,localStorage.getItem("MaskColor").split(','));

         
            
          formdata.append("jsonData", JSON.stringify(result));
          formdata.append("gestureFileName", filename);
          formdata.append("gender", gender);
          axios
            .post(
              authenticationData.ApiBaseURL +
                "/api/Administration/CreateTempCharacterGestureFile",
              formdata,
              {
                headers: {
                  "Content-Type": `multipart/form-data`,
                  "Access-Control-Allow-Origin": "*",
                  Authorization: "Bearer " + authData.access_token,
                },
              }
            )
            .then((response) => {
              if (index === array.length - 1) {
                resolve();
              }
            })
            .catch((excetion) => {});
        });
      });
    });
  };

  const timer = (ms) => new Promise((res) => setTimeout(res, ms));

  const ExportCharacter = async (element) => {
    const resp = await fetch(element);
    const jsonData = await resp.json();
    let updatedJsonData = await load(jsonData, element);

    //console.log(jsonData);

    return updatedJsonData;
  };

  async function load(jsonData, gestureName) {
    //console.log(JSON.parse(localStorage.getItem("Settings")));
    var settings = JSON.parse(localStorage.getItem("Settings"));
    if (settings == null) return;
    // We need to wrap the loop into an async function for this to work
    for (var i = 0; i < settings.length; i++) {
      for (var j = 0; j < PartNames.length; j++) {
        if (settings[i][PartNames[j].name] === null) {
          for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
            var name = jsonData.assets[0].layers[Layr].nm;
            if (
              PartNames[j].name.trim().toLowerCase() ===
              name.trim().toLowerCase()
            ) {
              jsonData.assets[0].layers[Layr].hd = true;
            }
          }
        } else {
          for (var Layr = 0; Layr < jsonData.assets[0].layers.length; Layr++) {
            var name = jsonData.assets[0].layers[Layr].nm;
            if (settings[i][PartNames[j].name]) {
              if (gestureName === settings[i].gestureName) {
                if (
                  PartNames[j].name.trim().toLowerCase() ===
                  name.trim().toLowerCase()
                ) {
                  var actualLayer = settings[i][PartNames[j].name];
                  // if (currentJSON.assets[0].layers[Layr] != null) {
                  //   actualLayer.parent =
                  //     currentJSON.assets[0].layers[Layr].parent;
                  // }
                  // if (currentJSON.assets[0].layers[Layr] != null) {
                  //   actualLayer.ind = currentJSON.assets[0].layers[Layr].ind;
                  // }
                  jsonData.assets[0].layers[Layr] = actualLayer;
                }
              }
            }
          }
        }
      }

      //await timer(100); // then the created Promise can be awaited
    }
    return jsonData;
  }

  const getALLDefaultGestures = (gender) => {
    axios
      .get(
        authenticationData.ApiBaseURL +
          "/api/Administration/getDefaultGesturesFiles?gender="+gender+"",
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: "Bearer " + authData.access_token,
          },
        }
      )
      .then((response) => {
        setAllDefaultGesturesJSON([...response.data.response]);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const setCharJSON = (e) =>{
    
    if(e.currentTarget.selectedIndex==1)
    {
        getALLDefaultGestures("Female");
        setGender("Female")
        getStaticCharacters("Female");
        setCurrentJSON(FData);
    }
    else
    {
      getALLDefaultGestures("Male");
      setGender("Male")
      getStaticCharacters("Male");
      setCurrentJSON(myData);
    }
  }

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.ShowSmartCharaterBuilderPanel}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.ShowSmartCharaterBuilderPanel}>
          <Box sx={style}>
            <Button
              size="small"
              color="error"
              onClick={closeCharachterbuilder}
              style={{ float: "right", marginRight: 5 }}
            >
              <CloseIcon />
            </Button>
            <Paper
              style={{
                height: "100%",
                width: "100%",
                borderRadius: 1,
                backgroundColor: "transparent",
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={1} md={4}>
                  <button onClick={ProceedToAppearanceWindow}>Proceed</button>
                  <button onClick={ProceedToOutfitWindow}>Back</button>
                  <button onClick={SaveNewCharacter}>Save</button>

                  <select onChange={(e) => setCharJSON(e)}>
                    <option id="1">Male</option>
                    <option id="2">Female</option>
                  </select>
                  <LottiePlayer
                    name="test"
                    style={{ height: "70%", width: "70%" }}
                    play
                    loop
                    animationData={currentJSON}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    {defaultColorSettings.length > 0 &&
                      defaultColorSettings.map((item, index) => (
                        <>
                          <FormLabel>{item.name}</FormLabel>
                          <SmartColorPicker
                            AllUpdatedGesturesJSON={allDefaultGesturesJSON}
                            Name={item.name}
                            key={index}
                            rgb={item.rgb}
                            isSmartBuilder={true}
                            charJSON={currentJSON}
                            value={item}
                            setCurrentJSON={setCurrentJSON}
                            myData={myData}
                          ></SmartColorPicker>
                        </>
                      ))}
                  </div>
                </Grid>
                {showAppearanceComp == false && (
                  <>
                    <Grid item xs={1} md={8}>
                      <label>Select Shirt</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setShirt}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setShirt}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <br />
                      <label>Select Bottom</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setPant}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setPant}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <br />

                      <label>Select Coat</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setCoat}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setCoat}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <br />

                      <label>Select Cap</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setCap}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setCap}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <br />

                      <label>Select Glasses</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setGlasses}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setGlasses}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>
                    </Grid>
                  </>
                )}

                {showAppearanceComp == true && (
                  <>
                    <Grid item xs={1} md={8}>
                      <label>Select Hair</label>
                      <div style={{ display: "flex" }}>
                        <button onClick={setHair} value="Null">
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setHair}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "90%", width: "90%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <br />
                      <label>Select Beard</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setBeard}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setBeard}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "90%", width: "90%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <br />
                      <label>Select Mask</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setMask}>
                          Null
                        </button>
                        {StaticData.map((value, index) => (
                          <div
                            style={{ height: "90%", width: "90%" }}
                            onClick={setMask}
                            key={index}
                            id={value.defaultPath}
                          >
                            <LottiePlayer
                              id={index}
                              style={{ height: "70%", width: "70%" }}
                              play
                              loop
                              path={
                                authenticationData.ApiBaseURL +
                                "/" +
                                value.defaultPath
                              }
                            />
                          </div>
                        ))}
                      </div>
                      <br />
                      <label>Select Earbuds</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setEarbud}>
                          Null
                        </button>
                      </div>
                      <br />
                      <label>Select Chain</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setChain}>
                          Null
                        </button>
                      </div>
                      <br />
                      <label>Select EarRing</label>
                      <div style={{ display: "flex" }}>
                        <button value="Null" onClick={setEarRing}>
                          Null
                        </button>
                      </div>
                    </Grid>
                  </>
                )}
              </Grid>
            </Paper>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default DefaultCharacterView;
